const updates = [
  {
    date: '2026.08.01',
    title: '《暗夜追踪》大结局上线',
    desc: '历经十二周的深夜追更，悬疑大片《暗夜追踪》终于迎来最终章，真相即将揭晓。',
    icon: 'ri-movie-2-line',
    color: 'text-primary-600',
    dotColor: 'bg-primary-500',
  },
  {
    date: '2026.07.29',
    title: '片库突破 20000 部里程碑',
    desc: '夜猫电影院高清影视资源总量正式突破两万大关，覆盖全类型满足每一个深夜观影需求。',
    icon: 'ri-trophy-line',
    color: 'text-accent-600',
    dotColor: 'bg-accent-500',
  },
  {
    date: '2026.07.26',
    title: '新增 4K 超清专区',
    desc: '热门影片新增 4K 超清播放选项，画质再升级。首批 200 部经典与热门影片已支持 4K 播放。',
    icon: 'ri-4k-line',
    color: 'text-primary-600',
    dotColor: 'bg-primary-500',
  },
  {
    date: '2026.07.22',
    title: '《午夜食堂》第四季定档',
    desc: '深夜美食治愈剧第四季正式定档，将于下周五凌晨首播，新角色新故事即将登场。',
    icon: 'ri-restaurant-line',
    color: 'text-secondary-600',
    dotColor: 'bg-secondary-500',
  },
  {
    date: '2026.07.18',
    title: '播放器全面优化升级',
    desc: '播放内核重写完成，缓冲速度提升 40%，夜间高峰时段的播放稳定性大幅改善。',
    icon: 'ri-speed-up-line',
    color: 'text-primary-600',
    dotColor: 'bg-primary-500',
  },
  {
    date: '2026.07.15',
    title: '纪录片专区正式开放',
    desc: '收录暗网、自然、历史、科技等题材精选纪录片，为深夜求知欲爆棚的夜猫子们准备。',
    icon: 'ri-file-text-line',
    color: 'text-accent-600',
    dotColor: 'bg-accent-500',
  },
  {
    date: '2026.07.11',
    title: '字幕组合作计划启动',
    desc: '与多家优质字幕团队达成合作，确保热门海外剧集上线后 24 小时内即可提供精准中文字幕。',
    icon: 'ri-translate',
    color: 'text-secondary-600',
    dotColor: 'bg-secondary-500',
  },
  {
    date: '2026.07.07',
    title: '《极限追凶》上线即登顶热度榜',
    desc: '犯罪动作新片《极限追凶》上线首日即冲上热度飙升榜首位，午夜高架追逐戏获观众好评。',
    icon: 'ri-fire-line',
    color: 'text-accent-600',
    dotColor: 'bg-accent-500',
  },
  {
    date: '2026.07.03',
    title: 'CDN 节点扩展至全国 30 城',
    desc: '加速节点新增成都、武汉、西安等 8 座城市，更多地区的夜猫子也能享受秒播观影体验。',
    icon: 'ri-cloud-line',
    color: 'text-primary-600',
    dotColor: 'bg-primary-500',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            夜猫电影院的大事小事，都在这里记录
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200"></div>

            <div className="space-y-0">
              {updates.map((item, i) => (
                <div key={i} className="relative flex gap-5 pb-6 last:pb-0">
                  <div className={`relative z-10 w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full ${item.dotColor} ring-4 ring-background-100`}>
                    <i className={`${item.icon} text-background-50 text-sm`}></i>
                  </div>

                  <div className="flex-1 min-w-0 pt-1.5">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">
                        {item.date}
                      </span>
                      <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                      <h3 className="text-sm font-semibold text-foreground-900">
                        {item.title}
                      </h3>
                    </div>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}